import { defineStyle } from '@chakra-ui/react';

import { BACKGROUND_COLORS } from '../tokens';
import { resolveColor } from '../utils';

// Exports
// 3rd party custom component used in <FilterDatePicker>
export const ChakraReactDatePicker = {
  baseStyle: defineStyle((props) => ({
    bg: resolveColor(props, BACKGROUND_COLORS.white.base),
  })),
};
